<template>
  <v-responsive :class="heroHeight" class="mb-3">
    <v-img
      :src="src"
      gradient="to top, rgba(161, 196, 253, 0.9), rgba(194, 233, 251, 0.8)"
      alt="Las Vegas skyline"
    >
      <v-layout
        justify-center
        align-center
        column
        fill-height
        style="z-index: 100;"
      >
        <h1
          :class="companyFontSize"
          class="mb-1 font-weight-medium blue--text text--darken-4"
        >
          {{ company | uppercase }}
        </h1>
        <h2
          :class="h1FontSize"
          class="font-weight-regular red--text text--darken-4"
        >
          Henderson and Las Vegas Real Estate
        </h2>
        <span
          :class="subheadingFontSize"
          class="font-weight-medium font-italic blue-grey--text text--darken-3"
        >
          We can help with all of your buying and selling needs
        </span>
      </v-layout>
    </v-img>
  </v-responsive>
</template>

<script>
import Image from '../assets/prg_lv.svg';

export default {
  name: 'TheHero',
  data() {
    return {
      // height: '',
      src: Image,
      company: 'PR Properties Group',
    };
  },
  computed: {
    // eslint-disable-next-line
    heroHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '240px';
        case 'sm':
        case 'md':
        case 'lg':
        case 'xl':
          return '450px';
      }
    },
    // eslint-disable-next-line
    companyFontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'headline';
        case 'sm':
          return 'display-2';
        case 'md':
        case 'lg':
          return 'display-3';
        case 'xl':
          return 'display-4';
      }
    },
    // eslint-disable-next-line
    h1FontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'subheading';
        case 'sm':
          return 'headline';
        case 'md':
        case 'lg':
          return 'display-1';
        case 'xl':
          return 'display-2';
      }
    },
    // eslint-disable-next-line
    subheadingFontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'caption';
        case 'sm':
        case 'md':
        case 'lg':
        case 'xl':
          return 'title';
      }
    },
  },
};
</script>
